import React, { useEffect, useState } from 'react';
import ScrollableSection from 'react-update-url-on-scroll';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardMedia from "@material-ui/core/CardMedia";
import makeStyles from "@material-ui/core/styles/makeStyles";


    
export default function Posts() {

    // --- Style --- //
    const useStyles = makeStyles({
      /**
       * Applied to Orginal Card demo
       * Same vale used in Material-ui Card Demos
       */
      media: {
        height: 400
      },

     
    });


    const [posts, setPosts] = useState([]);
    useEffect(() => {
        async function loadPosts() {
            const response = await fetch('http://localhost/era/wp-json/wp/v2/posts?_embed');
            if(!response.ok) {
                // oups! something went wrong
                return;
            }
    
            const posts = await response.json();
            
            setPosts(posts);
        }
    
        loadPosts();
   }, [])
   const classes = useStyles();
  return (
    <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" style={{ minHeight: '100vh' }}>
      {posts.map((post, index) => (

        <ScrollableSection name={ post.slug.toString() } key={post.slug.toString()} >
          <Grid item xs={8} key={index}>
            <Card>
              <CardContent>
                    <CardMedia
                        // sx={{ height: 140 }}
                        className={classes.media}
                        image={post && post._embedded && post._embedded['wp:featuredmedia'] ? post._embedded['wp:featuredmedia'][0].source_url : ' ' }
                      />
                    <Typography
                        color="textSecondary"
                        gutterBottom
                        dangerouslySetInnerHTML={{__html: post.title.rendered}} />
                    <Typography
                        variant="body2"
                        component="p"
                        dangerouslySetInnerHTML={{__html: post.content.rendered}} />
                </CardContent>
            </Card>
          </Grid>
        </ScrollableSection>
        
     ))}
    </Grid>
 );
}